import { useEffect, useState } from '@wordpress/element';
import styles from './ToggleSwitch.module.css';

const ToggleSwitch = ({ id, checked, onChange, label }) => {
  // Use internal state to track the checked value
  const [isChecked, setIsChecked] = useState(false);

  // Update internal state when prop changes
  useEffect(() => {
    // Ensure checked is a boolean - handle all possible values
    const checkedValue = checked === true || checked === 1 || checked === '1' || checked === 'true';
    setIsChecked(checkedValue);
  }, [checked, id]);

  const handleChange = (e) => {
    const newValue = e.target.checked;
    setIsChecked(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  
  return (
    <div className={styles['hvnly-settings-api__toggle-group']}>
      <label className={styles['hvnly-settings-api__toggle']}>
        <input
          type="checkbox"
          id={id}
          checked={isChecked}
          onChange={handleChange}
        />
        <span className={styles['hvnly-settings-api__slider']}></span>
      </label>
      <span className={styles['hvnly-settings-api__toggle-label']}>{label}</span>
    </div>
  );
};

export default ToggleSwitch;